import React from 'react';
import cx from 'classnames';
import { useArticles, useCategory } from '@elevio/kb-kit/lib/hooks';
import * as Category from '@elevio/kb-kit/lib/components/category';
function CategoryCard({ categoryId, className }) {
    const category = useCategory({ categoryId });
    const { totalCount } = useArticles({ categoryId });
    if (!category)
        return null;
    const subCategoriesCount = (category.subCategories || []).length;
    return (<Category.Link className={cx('card', 'category-card', className)} data-testid="category-link">
      <div className="card-icon-circle">?</div>
      <h2 className="card-title">{category.title}</h2>
    </Category.Link>);
}
export default CategoryCard;
